<template>
  <div>
    <component :is="layout">
      <router-view></router-view>
    </component>
    <div class="transparent-modal-bg">
      <div v-if="defer(1)">
        <base-modal
          v-for="componentName in componentNames"
          :modalId="componentName"
          :key="componentName"
        >
          <component :is="componentName"></component>
        </base-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from './main';
import { ka } from './utils/konalytics';
import DeferMixin from './mixins/Defer';
import { componentNames } from './components/modals/_index';
import { NotificationFunctions } from './functions/notificationFunctions';
const default_layout = 'default';

export default {
  name: 'app',
  data: function() {
    return { componentNames: componentNames };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    },
  },
  async created() {
    try {
      let garbagePlaces = await apiService.GetGarbagePlaces();
      let appData = await apiService.GetAppData();
    } catch (error) {
      console.log(error);
      NotificationFunctions.ErrorAlert(
        this.$t('ui_alertErrorTitle'),
        this.$t('ui_alertErrorMessage')
      );
    }
  },
  beforeDestroy() {},
  mounted() {},
  methods: {},
  mixins: [DeferMixin()],
};
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
